// extracted by mini-css-extract-plugin
export default {"banner":"MainPageBanner_banner__useXT","title":"MainPageBanner_title__my4be","shimmer":"MainPageBanner_shimmer__C0ijf"};